var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRectsImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 422,
    height: 28,
    viewBox: "0 0 422 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    width: 13.8516,
    height: 11.6889,
    transform: "matrix(-3.68865e-08 -1 -1 5.17991e-08 419.602 27.9023)",
    fill: "#090909"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    width: 13.8516,
    height: 11.6889,
    transform: "matrix(-3.68865e-08 -1 -1 5.17991e-08 394.146 27.9023)",
    fill: "#090909"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    width: 13.8516,
    height: 11.6889,
    transform: "matrix(-3.68865e-08 -1 -1 5.17991e-08 368.695 27.9023)",
    fill: "#090909"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    width: 13.8516,
    height: 11.6889,
    transform: "matrix(-3.68865e-08 -1 -1 5.17991e-08 343.238 27.9023)",
    fill: "#090909"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 13.8516,
    height: 11.6889,
    transform: "matrix(-3.68865e-08 -1 -1 5.17991e-08 317.779 27.9023)",
    fill: ""
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 13.8516,
    height: 11.6889,
    transform: "matrix(-3.68865e-08 -1 -1 5.17991e-08 292.328 27.9023)",
    fill: ""
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 13.8516,
    height: 11.6889,
    transform: "matrix(-3.68865e-08 -1 -1 5.17991e-08 266.869 27.9023)",
    fill: ""
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 13.8516,
    height: 11.6889,
    transform: "matrix(-3.68865e-08 -1 -1 5.17991e-08 241.416 27.9023)",
    fill: ""
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 13.8516,
    height: 11.6889,
    transform: "matrix(-3.68865e-08 -1 -1 5.17991e-08 215.957 27.9023)",
    fill: ""
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 13.8516,
    height: 11.6889,
    transform: "matrix(-3.68865e-08 -1 -1 5.17991e-08 190.5 27.9023)",
    fill: ""
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 13.8516,
    height: 11.6889,
    transform: "matrix(-3.68865e-08 -1 -1 5.17991e-08 165.051 27.9023)",
    fill: ""
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 13.8516,
    height: 11.6889,
    transform: "matrix(-3.68865e-08 -1 -1 5.17991e-08 139.59 27.9023)",
    fill: ""
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 13.8516,
    height: 11.6889,
    transform: "matrix(-3.68865e-08 -1 -1 5.17991e-08 114.139 27.9023)",
    fill: ""
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 13.8516,
    height: 11.6889,
    transform: "matrix(-3.68865e-08 -1 -1 5.17991e-08 88.6836 27.9023)",
    fill: ""
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 13.8516,
    height: 11.6889,
    transform: "matrix(-3.68865e-08 -1 -1 5.17991e-08 63.2227 27.9023)",
    fill: ""
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 13.8516,
    height: 11.6889,
    transform: "matrix(-3.68865e-08 -1 -1 5.17991e-08 37.7695 27.9023)",
    fill: ""
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    width: 13.8516,
    height: 11.6889,
    transform: "matrix(-3.68865e-08 -1 -1 5.17991e-08 12.3125 27.9023)",
    fill: ""
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M0.638672 1.22363H421.439",
    stroke: "black",
    strokeWidth: 1.02984
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectsImg);
export default __webpack_public_path__ + "static/media/rects-img.426ed889.svg";
export { ForwardRef as ReactComponent };